import { useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useAuth } from '@App/components/AuthProvider/auth-provider.context';
import {
  faBuilding, faBus, faCarSide, faMessages, 
} from '@fortawesome/pro-solid-svg-icons';

import Nav from '@App/components/Nav/Nav';
import Footer from '@App/components/Footer/Footer';
import Partners from '@App/components/Partners/Partners';
import RegisterForm from '@App/components/RegisterForm/RegisterForm';
import { useLoginModal } from '@services/hooks.service';
import { setShowContactModal } from '@App/app.slice';

import {
  Button, Icon,
  IconList, 
} from '@nazka/nazka.mapframe.components';

import './register-jobcoach.styl';

function RegisterJobcoach() {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const { setShowLoginModal } = useLoginModal();

  const {
    isLoggedIn,
  } = useAuth();

  const scrollToRegister = useCallback(() => {
    document.querySelector('.register-jobcoach__register h3').scrollIntoView({
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    if (searchParams.get('scrollToRegister')) {
      searchParams.delete('scrollToRegister');
      setSearchParams(searchParams, { replace: true });
      scrollToRegister();
    }
  }, [searchParams, setSearchParams, scrollToRegister]);

  return (
    <div className="register-jobcoach">
      <Nav />
      <div className="register-jobcoach__intro">
        <h1 className="register-jobcoach__intro__title">
          NaarJobs voor jobcoaches
        </h1>
        <h3 className="register-jobcoach__intro__subtitle">
          NaarJobs helpt de drempel rond mobiliteit en bereikbaarheid te overwinnen. 
          Versterk jezelf en voeg onze gratis tool vandaag nog toe aan jouw toolbox.
        </h3>
        <div className="register-jobcoach__intro__buttons">
          {!isLoggedIn && (
            <Button 
              className="register-jobcoach__intro__buttons__button"
              onClick={() => {
                setShowLoginModal('jobcoach');
                window.gtag?.('event', 'home_jobcoach_click_intro_login', {
                  event_category: 'Account',
                  event_label: 'Home jobcoach click into login button',
                });
              }}
            >
              Inloggen
            </Button>
          )}
          <Button 
            className="register-jobcoach__intro__buttons__button"
            onClick={() => {
              scrollToRegister();
              window.gtag?.('event', 'home_jobcoach_click_intro_register', {
                event_category: 'Account',
                event_label: 'Home jobcoach click into register button',
              });
            }}
          >
            Registreren
          </Button>
        </div>
      </div>
      <div className="register-jobcoach__info">
        <div className="register-jobcoach__info__image">
          <Icon className="register-jobcoach__info__image__icon" icon="/img/illustrations/icons.svg" />
        </div>
        <div className="register-jobcoach__info__text">
          <h3>Wat heeft NaarJobs jou als jobcoach te bieden?</h3>
          <p>
            Voor heel wat werkzoekenden is hun ideale job vaak dichterbij dan ze zelf denken. 
            Toch vormt mobiliteit al eens een drempel. Ben jij een jobcoach, arbeidsbemiddelaar 
            of toeleider? Dan help NaarJobs je om die mobiliteitsdrempels te overwinnen.
          </p>
          <p>
            Extra troeven voor jobcoaches:
          </p>
          <IconList
            className="register-employer__info__text__list"
            items={[
              {
                key: 0, 
                content: 'Ondersteun je klanten bij het zoeken naar een job dicht bij huis of een job die vlot bereikbaar is met fiets of openbaar vervoer.',
                iconProps: { icon: faBus },
              },
              {
                key: 1, 
                content: 'Zoek op bedrijf, want soms weet jij als jobcoach gewoon wat meer.',
                iconProps: { icon: faBuilding },
              },
              {
                key: 2, 
                content: 'Sollicitatie op een ander adres? Help ook hier je klanten op weg.',
                iconProps: { icon: faMessages }, 
              },
              {
                key: 3, 
                content: 'Bereken ook routes met de auto, want niet iedereen kan zomaar kiezen.',
                iconProps: { icon: faCarSide },
              },
            ]}
          />
          <p>
            Registreer je vandaag nog gratis op dit platform!
          </p>
        </div>
      </div>
      <div className="register-jobcoach__register">
        <div className="register-jobcoach__register__form">
          <h3>Registreren</h3>
          <RegisterForm
            setShowLoginModal={() => {
              setShowLoginModal('jobcoach');
              window.gtag?.('event', 'home_jobcoach_click_register', {
                event_category: 'Account',
                event_label: 'Home jobcoach click register button',
              });
            }}
            group="jobcoaches"
          />
        </div>
        <div className="register-jobcoach__register__image">
          <Icon className="register-jobcoach__register__image__icon" icon="/img/illustrations/navigation.svg" />
        </div>
      </div>
      <div className="register-jobcoach__content-block">
        <div className="register-jobcoach__content-block__wrapper">
          <div className="register-jobcoach__content-block__wrapper__info">
            <div className="register-jobcoach__content-block__wrapper__info__image">
              <Icon
                className="register-jobcoach__content-block__wrapper__info__image__icon" 
                icon="/img/illustrations/email-green.svg"
              />
            </div>
            <div className="register-jobcoach__content-block__wrapper__info__text">
              <h3>Contact</h3>
              <p>
                Zit je met een vraag of wil je graag met ons samenwerken? 
                {' Stuur een e-mail naar '}
                <a href="mailto:info@naarjobs.be">
                  info@naarjobs.be
                </a>
                {' of gebruik het contactformulier.'}
              </p>
              <Button
                className="register-jobcoach__content-block__wrapper__info__text__button"
                onClick={() => {
                  dispatch(setShowContactModal(true));
                }}
              >
                Contact
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Partners />
      <Footer />
    </div>
  );
}

export default RegisterJobcoach;
